import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import states from "./States.json";
import { Controller } from 'react-hook-form';
import InputField from "./InputField";

function StateField({ label, name, placeholder, control, dependsOn, prefix, field, readOnly }) {
    const { setValue, watch, getValues } = useFormContext();

    const [countries, setCountries] = useState([]);
    const [fieldType, setFieldType] = useState('input');

    function getText(key) {
        const completeKey = `${prefix}.${key}`;

        return getValues(completeKey) ?? "";
    }

    const country = watch(dependsOn);

    useEffect(() => {
        switch (country) {
            case 'US':
                setCountries(states['usa']);
                setFieldType('select');
                break;
            case 'CA':
                setCountries(states['canada']);
                setFieldType('select');
                break;
            default:
                setCountries([]);
                setValue(`${prefix}.${field.key}`, '');
                setFieldType('input');
                break;
        }
    }, [country]);

    if (fieldType === 'select') {
        return (
            <Controller
                control={control}
                name={name}
                render={({ field: { onChange, value }, fieldState: { error } }) => (
                    <div>
                        {
                            fieldType === 'select' && <>
                                {
                                    label && <label htmlFor=""
                                                    className="checkout__label">{label}</label>
                                }
                                {
                                    fieldType === 'select' &&
                                    <select className="checkout__input" name="" id=""
                                            defaultValue={getText(field)}
                                            value={value}
                                            disabled={readOnly}
                                            onChange={onChange}
                                    >
                                        <option value="" selected disabled hidden>Select state</option>
                                        {
                                            countries.map(x => {
                                                return (
                                                    <option value={x.abbreviation}>{x.abbreviation} - {x.name}</option>);
                                            })
                                        }
                                    </select>
                                }

                            </>
                        }
                        {error &&
                            <p className="checkout__input-validation-error">{error.message}</p>}
                    </div>
                )}
            />
        )
    }

    if(fieldType === 'input'){
        return (
            <InputField
                name={name}
                control={control}
                label={label}
                placeholder={placeholder}
                readOnly={readOnly}
            />
        )
    }

    return null;
}

export default StateField;
